import React, { Fragment, useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  Input,
  ModalContent,
  ModalHeader,
  Grid,
  ModalFooter,
  Box,
  ModalBody,
  ModalCloseButton,
  Card,
  HStack,
  Text,
  Heading,
  CardBody,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { getImageGallery, uploadImage } from "../Services/api";
import { useQuery } from "react-query";
import PrimaryButton from "./themeComponents/PrimaryButton";
import { useToken } from "@chakra-ui/react";
import SwitchableTabs from "./themeComponents/SwitchableTabs";
import OutlinedButton from "./themeComponents/OutlinedButton";
import { HiOutlineCloudUpload } from "react-icons/hi";
import Pagination from "./Pagination"; // Import the generic Pagination component

export default function ImageGallery({ setImageData, renderComponent }) {
  const [mainColor] = useToken("colors", ["primary.main"]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const { isOpen, onOpen, onClose } = useDisclosure();

  const imageGalleryQuery = useQuery(
    ["images", currentPage, pageSize],
    async () => {
      const imagesList = await getImageGallery(currentPage, pageSize);
      setTotalCount(imagesList?.data?.count ?? 0);
      return imagesList;
    },
    {
      staleTime: 0, // Ensure fresh data on page change
      retry: 1,
    }
  );

  const postImage = async (file) => {
    const resp = await uploadImage(file);
    if (resp) {
      imageGalleryQuery.refetch();
    }
  };

  const tabContent = [
    { label: "Images" },
    { label: "Products" },
  ];

  const selectImage = (image) => {
    
    setImageData(image);
    onClose();
  };

  return (
    <Fragment>
      <Box onClick={onOpen}>{renderComponent}</Box>
      <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading fontSize="xl">Gallery</Heading>
            <SwitchableTabs tabContent={tabContent} />
          </ModalHeader>
          <ModalCloseButton onClick={onClose} />
          <ModalBody maxH="700px" overflowY="auto">
            <label
              style={{
                display: "flex",
                color: mainColor,
                background: "transparent",
                textDecoration: "underline",
                width: "fit-content",
                alignItems: "center",
                gap: "4px",
                padding: "8px 16px",
                fontSize: "16px",
                cursor: "pointer",
                borderRadius: "4px",
                marginBottom: "10px",
              }}
            >
              Upload Image <HiOutlineCloudUpload />
              <input
                style={{
                  opacity: 0,
                  width: "0",
                  height: "0",
                  position: "absolute",
                  cursor: "pointer",
                }}
                name="image"
                type="file"
                aria-hidden="true"
                accept="image/*"
                onChange={(event) => {
                  postImage(event.currentTarget.files[0]);
                }}
              />
            </label>
            {imageGalleryQuery.isLoading && <Text>Loading...</Text>}
            {!imageGalleryQuery.isLoading &&
              imageGalleryQuery?.data?.data?.images?.length < 1 && (
                <Text>No data available</Text>
              )}
            {!imageGalleryQuery.isLoading &&
              imageGalleryQuery?.data?.data?.images?.length > 0 && (
                <Grid gap="5px" templateColumns="repeat(4, 1fr)">
                  {imageGalleryQuery.data.data.images.map((item) => (
                    <Card
                      key={item.id || item.mediaFileUrl} // Added key for React list rendering
                      onClick={() => selectImage(item)}
                      direction={{ base: "column", sm: "row" }}
                      overflow="hidden"
                      variant="outline"
                      backgroundImage={item.mediaFileUrl}
                      height="10vw"
                      cursor="pointer"
                      width="10vw"
                      title="Select Image"
                      _hover={{ ".text": { opacity: 1 }, borderColor: "blue.500" }}
                    >
                      <Stack w="100%">
                        <CardBody w="100%">
                          <HStack
                            w="100%"
                            height="100%"
                            alignItems="end"
                            justifyContent="space-between"
                          >
                            <Text size="sm" className="text" opacity="0">
                              {item?.fileName}
                            </Text>
                          </HStack>
                        </CardBody>
                      </Stack>
                    </Card>
                  ))}
                </Grid>
              )}
          </ModalBody>
          <ModalFooter position="relative">
            {!imageGalleryQuery.isLoading &&
              imageGalleryQuery?.data?.data?.images?.length > 0 && (
                <Box position="absolute" bottom={0} right={0}>
                  <Pagination
                    totalCount={totalCount}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onPageChange={setCurrentPage}
                    isDisabled={imageGalleryQuery.isLoading}
                  />
                </Box>
              )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Fragment>
  );
}